import axios from 'axios'
import config from '../config/config'

export async function uploadFile(file) {
  const data = new FormData()
  data.append('file', file)

  return axios
    .post(config.baseUrl + 'uploads/S3', data, getOptions())
    .then((response) => {
      return response.data
    })

}

function getOptions() {
  let options = {};
  //let authdata = window.btoa('gestorrp:gestor2414#');
  var token = localStorage.getItem('token');
  if (token === undefined) {
    token = 'gestorrp:gestor2414#';
  }
  let authdata = window.btoa(token);
  options.headers = { 'Authorization': 'Basic ' + authdata };
  return options;
}
